import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { Button, Card, CardBody, Col, Form, Row } from "react-bootstrap";
import * as yup from "yup";
import { IFloorType } from "../../shared/interfaces/floor-type/IFloorType";
import { FloorTypeService } from "./service";
import { useUnsavedChanges } from "../../shared/hooks/useUnsavedChanges";

const schema = yup.object().shape({
  name: yup.string().required("validation.required"),
});

const FloorTypeForm = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm<IFloorType>({
    resolver: yupResolver(schema) as any,
    defaultValues: isEdit
      ? async () => {
          try {
            return await FloorTypeService.getSingle(+id!);
          } catch (e) {
            console.error(e);
          }
        }
      : {
          name: "",
        },
  });

  const { guardedNavigate, unsavedChangesModal } = useUnsavedChanges(isDirty);

  const onSubmit = async (data: IFloorType) => {
    try {
      if (isEdit) {
        await FloorTypeService.update(data, +id!);
      } else {
        await FloorTypeService.create(data);
      }
      SuccessToast(
        t(`floorType.${isEdit ? "successUpdate" : "successCreate"}`),
      );
      navigate("/floor-types");
      reset();
    } catch (error) {
      ErrorToast(error);
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col sm={12}>
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="g-3">
                  <Col sm={12} xl={6}>
                    <Form.Label className={"required"}>
                      {t("floorType.name")}
                    </Form.Label>
                    <Controller
                      name="name"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <Form.Control
                            type="text"
                            isInvalid={!!fieldState.error}
                            placeholder={t("floorType.enterName")}
                            {...field}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(fieldState.error?.message as string)}
                          </Form.Control.Feedback>
                        </>
                      )}
                    />
                  </Col>
                  <Col sm={12} className="d-flex gap-2">
                    <Button type="submit" variant="primary">
                      {t(`floorType.${isEdit ? "update" : "create"}`)}
                    </Button>
                    <Button type="button" variant="secondary" onClick={() => guardedNavigate("/floor-types")}>
                      {t("button.cancel")}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {unsavedChangesModal}
    </React.Fragment>
  );
};

export default FloorTypeForm;
